import  * as React from "react";
import { observer } from "mobx-react";
import { IGeneralSummaryItemProps } from "./IGeneralSummaryItemProps";

@observer
export class GeneralSummaryItem extends React.Component<IGeneralSummaryItemProps>{
    constructor(props: IGeneralSummaryItemProps) {
        super(props, undefined);
    }
    
    render() {
        var valueAsString = this.props.value.toString();
        var renderedValue = ((valueAsString.trim() === "") || (valueAsString.trim().length === "")) ? '-' : this.props.value;

        return <div className={this.props.className}>
                   <p>{this.props.name}</p>

                   <p><span>{renderedValue}</span>
                       {this.props.unit ? <span>{this.props.unit}</span> : ''
                       }
                   </p>
               </div>;
    }
}
